import * as cssVariables from 'cssVariables';

export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: cssVariables.grey100,
    height: 230,
    padding: 10,
  },
  title: {
    padding: 15,
    fontSize: cssVariables.fontSizes.medium,
    fontWeight: cssVariables.fontWeights.bold,
  },
  auth: {
    display: 'flex',
    marginLeft: 15,
  },
  authButton: {
    textTransform: 'capitalize',
    marginRight: 15,
  },
  closeIcon: {
    '& > svg': {
      height: 40,
      width: 40,
    },
    color: cssVariables.grey500,
    cursor: 'pointer',
    position: 'absolute',
    right: 10,
    top: 10,
  },
  icon: {
    '& > svg': {
      height: 55,
      width: 55,
    },
    '& path': {
      fill: cssVariables.grey500,
    },
  },
};
